import Crud from './crud'
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
var crud = new Crud('report-money-vnd', 'báo cáo thu chi');

const state = {
    ...crud.state,
    summary: {
        items:[],
        last_time: []
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getSummary({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('summary-money-vnd', data => {
            commit('setSummary', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
};
const mutations = {
    ...crud.mutations,
    setSummary(state, ret) {
        state.summary = ret.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};